import React from 'react';

import PickupDropdown from './dropdown';
import { PickupLabel } from './label';
import { useIsLocalDeliveryServiceSelected } from '../../hooks/use-is-local-delivery-service-selected';

import style from '../style.module.less';

const PickupWithLabel = () => {
  const isPickupServiceSelectedInCSW = useIsLocalDeliveryServiceSelected();
  // TODO: put this logic in the dropdown component, there are some other changes coming in that could impact this so leave out for now

  return (
    isPickupServiceSelectedInCSW && (
      <>
        <label className={style.label}>
          <PickupLabel />
        </label>
        <PickupDropdown />
        <div />
      </>
    )
  );
};

export default PickupWithLabel;
